const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  userData: null,
  token: "",
  refreshToken: "",
  productItem: null,
  // Ids of my discussion threads with unread messages → header badge + row dots.
  unreadThreadIds: [],
};

export const userDataSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    userData: (state, action) => {
      state.userData = action.payload;
    },
    accessToken: (state, action) => {
      state.token = action.payload;
    },
    refreshToken: (state, action) => {
      state.refreshToken = action.payload;
    },
    productItem: (state, action) => {
      state.productItem = action.payload;
    },
    setUnreadThreadIds: (state, action) => {
      state.unreadThreadIds = Array.isArray(action.payload) ? action.payload : [];
    },
  },
});

export const {
  userData,
  accessToken,
  refreshToken,
  productItem,
  setUnreadThreadIds,
} = userDataSlice.actions;

export default userDataSlice.reducer;
